import { formatDateTime } from 'utils/formattedString';
import { Link } from 'react-router-dom';
import { Typography } from 'antd';
import i18n from 'i18n';
import { DynamicObjectType } from 'core/types/common';
import CustomerLabel from 'containers/Orders/components/CustomerLabel';
import StatusLabel from '../components/StatusLabel';
import {
  ORDER_TTB_CANCEL_REASONS,
  ORDER_TTB_STATUS,
} from 'constants/ordersTabTryBuy';
import { upperFirst } from 'lodash';

const cancelReasonText = (d: string) => {
  return i18n.t(ORDER_TTB_CANCEL_REASONS.find((e) => e?.value === d)?.text);
};

export const getColumns = (status) => {
  switch (status) {
    case ORDER_TTB_STATUS['AWAITING_CONFIRMATION']?.value:
      return [
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-keep-and-try/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },

        {
          name: 'createdAt',
          title: i18n.t('ordersTabTryBuy.createdTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'statusOms',
          title: i18n.t('ordersTabTryBuy.ttbStatus'),
          render: (d) => <StatusLabel status={d} dataFull={ORDER_TTB_STATUS} />,
          isDefault: true,
        },
        {
          name: 'itemsCount',
          title: i18n.t('ordersTabTryBuy.totalItems'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'location',
          title: i18n.t('ordersTabTryBuy.pickupStore'),
          render: (d: DynamicObjectType) => (
            <p className="min-w-[120px]">
              {d?.id && `${d?.code || ''} | ${d?.name || ''}`}
            </p>
          ),
          isDefault: true,
        },
        {
          name: 'customer',
          title: i18n.t('ordersTabTryBuy.customerName'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
        {
          name: 'customer.telephone',
          title: i18n.t('ordersTabTryBuy.phoneNumber'),
          render: (d, rc: DynamicObjectType) => (
            <div className="min-w-[120px]">
              {rc?.isMarketPlace || !rc?.customerId
                ? rc?.address?.telephone
                : d}
            </div>
          ),
          isDefault: true,
        },
        {
          name: 'channelDisplay',
          title: i18n.t('ordersTabTryBuy.channel'),
          render: (d: string) => (
            <p className="min-w-[120px]">{upperFirst(d)}</p>
          ),
          isDefault: true,
        },
      ];
    case ORDER_TTB_STATUS['CONFIRMED']?.value:
      return [
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-keep-and-try/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'confirmationTime',
          title: i18n.t('ordersTabTryBuy.confirmedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'statusOms',
          title: i18n.t('ordersTabTryBuy.ttbStatus'),
          render: (d) => <StatusLabel status={d} dataFull={ORDER_TTB_STATUS} />,
          isDefault: true,
        },
        {
          name: 'itemsCount',
          title: i18n.t('ordersTabTryBuy.totalItems'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'numberOfTO',
          title: i18n.t('ordersTabTryBuy.numberOfTO'),
          render: (d: number, rc: DynamicObjectType) => (
            <p className="min-w-[120px]">{rc?.transferOrders?.length || 0}</p>
          ),
          isDefault: true,
        },
        {
          name: 'location',
          title: i18n.t('ordersTabTryBuy.pickupStore'),
          render: (d: DynamicObjectType) => (
            <p className="min-w-[120px]">
              {d?.id && `${d?.code || ''} | ${d?.name || ''}`}
            </p>
          ),
          isDefault: true,
        },
        {
          name: 'customer',
          title: i18n.t('ordersTabTryBuy.customerName'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
        {
          name: 'customer.telephone',
          title: i18n.t('ordersTabTryBuy.phoneNumber'),
          render: (d, rc: DynamicObjectType) => (
            <div className="min-w-[120px]">
              {rc?.isMarketPlace || !rc?.customerId
                ? rc?.address?.telephone
                : d}
            </div>
          ),
          isDefault: true,
        },
        {
          name: 'channelDisplay',
          title: i18n.t('ordersTabTryBuy.channel'),
          render: (d: string) => (
            <p className="min-w-[120px]">{upperFirst(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'partner',
          title: i18n.t('orders.deliveryPartner'),
          render: (dt: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <div className="min-w-[120px]">
                {rc?.shippingCarrier?.name || ''}
              </div>
            );
          },
        },
        {
          name: 'deliveryCode',
          title: i18n.t('orders.shippingNo'),
          render: (dt, rc) => {
            return <div className="min-w-[150px]">{rc?.deliveryCode}</div>;
          },
        },
      ];
    case ORDER_TTB_STATUS['DELIVERING']?.value:
      return [
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-keep-and-try/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'handedOverTime',
          title: i18n.t('ordersTabTryBuy.deliveringTime'),
          render: (d) => (
            <p style={{ minWidth: 200 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 200,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'statusOms',
          title: i18n.t('ordersTabTryBuy.ttbStatus'),
          render: (d) => <StatusLabel status={d} dataFull={ORDER_TTB_STATUS} />,
          isDefault: true,
        },
        {
          name: 'itemsCount',
          title: i18n.t('ordersTabTryBuy.totalItems'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'numberOfTO',
          title: i18n.t('ordersTabTryBuy.numberOfTO'),
          render: (d: number, rc: DynamicObjectType) => (
            <p className="min-w-[120px]">{rc?.transferOrders?.length || 0}</p>
          ),
          isDefault: true,
        },
        {
          name: 'location',
          title: i18n.t('ordersTabTryBuy.pickupStore'),
          render: (d: DynamicObjectType) => (
            <p className="min-w-[120px]">
              {d?.id && `${d?.code || ''} | ${d?.name || ''}`}
            </p>
          ),
          isDefault: true,
        },
        {
          name: 'customer',
          title: i18n.t('orders.customer'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
        {
          name: 'customer.telephone',
          title: i18n.t('ordersTabTryBuy.phoneNumber'),
          render: (d, rc: DynamicObjectType) => (
            <div className="min-w-[120px]">
              {rc?.isMarketPlace || !rc?.customerId
                ? rc?.address?.telephone
                : d}
            </div>
          ),
          isDefault: true,
        },
        {
          name: 'channelDisplay',
          title: i18n.t('ordersTabTryBuy.channel'),
          render: (d: string) => (
            <p className="min-w-[120px]">{upperFirst(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'partner',
          title: i18n.t('orders.deliveryPartner'),
          render: (dt: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <div className="min-w-[120px]">
                {rc?.shippingCarrier?.name || ''}
              </div>
            );
          },
        },
        {
          name: 'deliveryCode',
          title: i18n.t('orders.shippingNo'),
          render: (dt, rc) => {
            return <div className="min-w-[150px]">{rc?.deliveryCode}</div>;
          },
        },
      ];
    case ORDER_TTB_STATUS['READY_TO_TRY']?.value:
      return [
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-keep-and-try/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },

        {
          name: 'readyToTryTime',
          title: i18n.t('ordersTabTryBuy.readyToTryTime'),
          render: (d) => (
            <div style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</div>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'statusOms',
          title: i18n.t('ordersTabTryBuy.ttbStatus'),
          render: (d) => <StatusLabel status={d} dataFull={ORDER_TTB_STATUS} />,
          isDefault: true,
        },
        {
          name: 'itemsCount',
          title: i18n.t('ordersTabTryBuy.totalItems'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'location',
          title: i18n.t('ordersTabTryBuy.pickupStore'),
          render: (d: DynamicObjectType) => (
            <p className="min-w-[120px]">
              {d?.id && `${d?.code || ''} | ${d?.name || ''}`}
            </p>
          ),
          isDefault: true,
        },
        {
          name: 'customer',
          title: i18n.t('orders.customer'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
        {
          name: 'customer.telephone',
          title: i18n.t('ordersTabTryBuy.phoneNumber'),
          render: (d, rc: DynamicObjectType) => (
            <div className="min-w-[120px]">
              {rc?.isMarketPlace || !rc?.customerId
                ? rc?.address?.telephone
                : d}
            </div>
          ),
          isDefault: true,
        },
        {
          name: 'channelDisplay',
          title: i18n.t('ordersTabTryBuy.channel'),
          render: (d: string) => (
            <p className="min-w-[120px]">{upperFirst(d)}</p>
          ),
          isDefault: true,
        },
      ];
    default:
      return [
        {
          name: 'orderNumber',
          title: 'Order No',
          render: (d: string, record: DynamicObjectType) => (
            <Link to={`/orders-keep-and-try/${record?.id}/show`}>
              <Typography.Paragraph
                ellipsis={{ rows: 1 }}
                style={{ width: 150, color: '#AB2328' }}
              >
                #{d}
              </Typography.Paragraph>
            </Link>
          ),
          isDefault: true,
        },
        {
          name: 'createdAt',
          title: i18n.t('ordersTabTryBuy.createdTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'statusOms',
          title: i18n.t('ordersTabTryBuy.ttbStatus'),
          render: (d) => (
            <div className="min-w-[100px]">
              <StatusLabel status={d} dataFull={ORDER_TTB_STATUS} />
            </div>
          ),
          isDefault: true,
        },
        {
          name: 'itemsCount',
          title: i18n.t('ordersTabTryBuy.totalItems'),
          render: (d: number) => <p className="min-w-[120px]">{d}</p>,
          isDefault: true,
        },
        {
          name: 'location',
          title: i18n.t('ordersTabTryBuy.pickupStore'),
          render: (d: DynamicObjectType) => (
            <p className="min-w-[120px]">
              {d?.id && `${d?.code || ''} | ${d?.name || ''}`}
            </p>
          ),
          isDefault: true,
        },
        {
          name: 'customer',
          title: i18n.t('ordersTabTryBuy.customerName'),
          render: (d: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <CustomerLabel
                data={
                  rc?.isMarketPlace || !rc?.customerId
                    ? rc?.address
                    : rc?.customer
                }
                sizeClass="text-[14px]"
              />
            );
          },
          isDefault: true,
          width: 120,
        },
        {
          name: 'customer.telephone',
          title: i18n.t('ordersTabTryBuy.phoneNumber'),
          render: (d, rc: DynamicObjectType) => (
            <div className="min-w-[120px]">
              {rc?.isMarketPlace || !rc?.customerId
                ? rc?.address?.telephone
                : d}
            </div>
          ),
          isDefault: true,
        },
        {
          name: 'channelDisplay',
          title: i18n.t('ordersTabTryBuy.channel'),
          render: (d: string) => (
            <p className="min-w-[120px]">{upperFirst(d)}</p>
          ),
          isDefault: true,
        },
        {
          name: 'partner',
          title: i18n.t('orders.deliveryPartner'),
          render: (dt: DynamicObjectType, rc: DynamicObjectType) => {
            return (
              <div className="min-w-[120px]">
                {rc?.shippingCarrier?.name || ''}
              </div>
            );
          },
        },
        {
          name: 'deliveryCode',
          title: i18n.t('orders.shippingNo'),
          render: (dt, rc) => {
            return <div className="min-w-[150px]">{rc?.deliveryCode}</div>;
          },
        },
        {
          name: 'confirmationTime',
          title: i18n.t('ordersTabTryBuy.confirmedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'handedOverTime',
          title: i18n.t('ordersTabTryBuy.deliveringTime'),
          render: (d) => (
            <p style={{ minWidth: 180 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'readyToTryTime',
          title: i18n.t('ordersTabTryBuy.readyToTryTime'),
          render: (d) => (
            <p style={{ minWidth: 180 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'deliveryCompletedTime',
          title: i18n.t('ordersTabTryBuy.completedTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'cancelTime',
          title: i18n.t('ordersTabTryBuy.cancelledTime'),
          render: (d) => (
            <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
          ),
          width: 150,
          isDefault: true,
          sorter: true,
        },
        {
          name: 'cancelReason',
          title: i18n.t('ordersTabTryBuy.cancelledReason'),
          render: (d: string) => (
            <p className="min-w-[150px]">{d ? cancelReasonText(d) : ''}</p>
          ),
          isDefault: true,
        },
        {
          name: 'cancelledBy',
          title: i18n.t('ordersTabTryBuy.cancelledBy'),
          render: (d: DynamicObjectType) => (
            <p className="min-w-[120px]">{`${d?.firstName || ''} ${d?.lastName || ''}`}</p>
          ),
          isDefault: true,
        },
      ];
  }
};
